import axiosPrivateMl from "./axiosPrivateMl"

const sheetCreateAdSet = async (payload) => {
  const response = await axiosPrivateMl.post("/sheet_create_adsets", payload)
  return response.data
}

const sheetPublishAdSet = async (payload) => {
  try {
    const response = await axiosPrivateMl.post("/sheet_publish_ads", payload)
    console.log("Response status code:", response.status)
    return response.data
  } catch (error) {
    if (error.response && error.response.status === 504) {
      console.log("Gateway timeout (504) encountered")
      return { success: true, data: [] }
    }
    throw error // re-throw other errors
  }
}


export { sheetCreateAdSet, sheetPublishAdSet };
